import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics';

Vue.use(Router);

const routerOptions = [
  {
    path: '*',
    component: 'NotFound/NotFound'
  },
  {
    path: '/',
    component: 'Home/Home'
  },
  {
    path: '/6-klasse',
    component: '6thGrade/6thGrade'
  },
  {
    path: '/9-klasse',
    component: '9thGrade/9thGrade'
  },
  {
    path: '/6-klasse/laerer',
    component: '6thGrade/Teacher/Teacher'
  },
  {
    path: '/6-klasse/brannvesen-og-dle',
    component: '6thGrade/Instructor/Instructor'
  },
  {
    path: '/6-klasse/spill',
    component: '6thGrade/Game/Game'
  },
  {
    path: '/6-klasse/registrer',
    component: '6thGrade/Register/Register'
  },
  {
    path: '/6-klasse/resultater',
    component: '6thGrade/Results/Results'
  },
  {
    path: '/6-klasse/resultater/:year/:schoolid',
    component: '6thGrade/Results/Results'
  },
  {
    path: '/6-klasse/resultater/:year/:schoolid/:klass',
    component: '6thGrade/Results/Results'
  },
  {
    path: '/9-klasse/filmer',
    component: '9thGrade/Films/Films'
  },
  {
    path: '/9-klasse/laerer',
    component: '9thGrade/Teacher/Teacher'
  },
  {
    path: '/9-klasse/brannvesen-og-dle',
    component: '9thGrade/Instructor/Instructor'
  },
  {
    path: '/terms',
    component: 'Terms/Terms'
  }
]

// Import rout components
const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-7989857-13',
  router
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js